import { useCallback, useMemo } from 'react';

import { FormOutlined, CalendarOutlined } from '@ant-design/icons';
import { MenuProps } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { Outlet, useNavigate } from 'react-router-dom';

import { Sidenav } from '@/components/navigation/Sidenav';
import { ROUTES } from '@/config/routes';
import { DefaultLayout } from '@/layouts/DefaultLayout';

export const CalendarLayout = () => {
  const navigate = useNavigate();

  const calendarLink = ROUTES.getLink(`calendar`);
  const servicesLink = ROUTES.getLink(`irm.services.catalogo`);

  const sidenavItems: ItemType[] = useMemo(
    () => [
      {
        label: `Central de Rotinas`,
        key: calendarLink,
        icon: <CalendarOutlined />,
      },
      {
        label: `Catálogo`,
        key: servicesLink,
        icon: <FormOutlined />,
      },
    ],
    [calendarLink, servicesLink],
  );

  const handleSelectItem = useCallback<NonNullable<MenuProps['onClick']>>(
    (e) => {
      if (e.key === servicesLink) {
        navigate(servicesLink);
      }

      if (e.key === calendarLink) {
        navigate(calendarLink);
      }
    },
    [navigate, servicesLink, calendarLink],
  );

  return (
    <>
      <Sidenav items={sidenavItems} onSelectItem={handleSelectItem} />
      <DefaultLayout>
        <Outlet />
      </DefaultLayout>
    </>
  );
};
